const getters = {
	getErrorMessage: (state, getters) => {
        return state.errorMessage;
    },
    getSuccessMessage: (state, getters) => {
        return state.successMessage;
    },
    getAllCourse: (state, getters) => {
        return state.courseList;
    },
    getCourse: (state, getters) => {
        return state.course;
    },
    getMyCourse: (state, getters) => {
        return state.myCourse;
    },
    getMineCourse: (state, getters) => {
        return state.mineCourse;
    },
  getSchoolSiteVersion: (state, getters) => {
    return state.schoolVersion;
  },
};

export default getters;



// WEBPACK FOOTER //
// ./src/getters/school.js